import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";

export function RulesTests() {
  const [d, setD] = useState(null);
  const run = () => { setD(null); api.get("/platform/rules-tests").then(({ data }) => setD(data)); };
  useEffect(() => { run(); }, []);
  return (
    <div className={card} data-testid="admin-rules-tests">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading text-xl text-ec-green">Testes das verificações</h2>
        <button onClick={run} className="text-sm font-semibold text-ec-green underline" data-testid="admin-rules-run">Correr de novo</button>
      </div>
      {!d ? <p className="text-sm text-slate-500 mt-3">A correr…</p> : (
        <>
          <p className="text-sm mt-2" data-testid="admin-rules-summary"><b>{d.passed}/{d.total}</b> casos passaram (documentos de exemplo anonimizados).</p>
          <ul className="mt-3 divide-y divide-slate-100">
            {d.results.map((r) => (
              <li key={r.id} className="py-2 flex items-start gap-2 text-sm" data-testid={`admin-rule-${r.id}`}>
                {r.passed ? <CheckCircle2 size={16} className="text-green-600 mt-0.5 shrink-0" /> : <XCircle size={16} className="text-red-600 mt-0.5 shrink-0" />}
                <span className="min-w-0"><span className="font-medium text-slate-800">{r.passed ? "Passou" : "Falhou"}</span> · {r.title}
                  {r.missing.length > 0 && <span className="block text-xs text-red-700">Faltou: {r.missing.join(", ")}</span>}
                  {r.unexpected.length > 0 && <span className="block text-xs text-red-700">Aviso a mais: {r.unexpected.join(", ")}</span>}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export function FalseAlarms() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/false-alarms").then(({ data }) => setD(data)); }, []);
  if (!d) return null;
  return (
    <div className={card} data-testid="admin-false-alarms">
      <h2 className="font-heading text-xl text-ec-green">Falsos alarmes</h2>
      <p className="text-sm text-slate-600 mt-1" data-testid="admin-false-alarms-total">{d.false} de {d.total} avisos marcados como falso alarme ({d.pct}%).</p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-slate-500"><th className="py-1.5 pr-3 font-medium">Verificação</th><th className="py-1.5 pr-3 font-medium text-right">Avisos</th><th className="py-1.5 pr-3 font-medium text-right">Falsos</th><th className="py-1.5 font-medium text-right">%</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {d.rows.map((r) => (
              <tr key={r.rule_id} data-testid={`admin-fa-${r.rule_id}`}>
                <td className="py-1.5 pr-3"><span className="text-slate-800">{r.title}</span> <span className="text-xs text-slate-400">{r.rule_id}</span></td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.total}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.false}</td>
                <td className={`py-1.5 text-right tabular-nums font-semibold ${r.pct >= 10 ? "text-red-700" : "text-slate-700"}`}>{r.pct}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
